import { useEffect, type ReactNode } from 'react';
import { useAuthStore } from '@features/auth/store';
import { authApi } from '@api/auth';

interface AuthProviderProps {
  children: ReactNode;
}

export function AuthProvider({ children }: AuthProviderProps) {
  const isHydrated = useAuthStore((s) => s.isHydrated);
  const setHydrated = useAuthStore((s) => s.setHydrated);
  const accessToken = useAuthStore((s) => s.accessToken);
  const setUser = useAuthStore((s) => s.setUser);

  useEffect(() => {
    if (!isHydrated) {
      setHydrated();
      return;
    }
    // Oturum açıksa profili (rol/izin claim'leri dahil) tazele. RolesPage'de
    // izinleri değişen bir kullanıcı, tam yeniden giriş gerekmeden sayfa
    // yenilemesinde güncel izinleri alır. 401 olursa http interceptor yönetir.
    if (!accessToken) return;
    let cancelled = false;
    void authApi
      .me()
      .then((user) => {
        if (!cancelled) setUser(user);
      })
      .catch(() => {
        /* interceptor 401'i yönetir; diğer hatalarda mevcut oturum korunur */
      });
    return () => {
      cancelled = true;
    };
  }, [isHydrated, accessToken, setHydrated, setUser]);

  return <>{children}</>;
}
